export default "__VITE_ASSET__DBiPKZG$__"